import styles from './ImageCard.module.css'


interface CardProps {
    imageUrl?: string;
    title: string;
    description: string;
    seeMore: string;
}
export default function ImageCard({ imageUrl, title, description, seeMore }: CardProps){
    return (
    <div className={styles.card}>
        {imageUrl && <img src={imageUrl} alt="imagem" />}
        
        <div className={styles.container}>

        <p className={styles.cardTitle}>{title}</p>

        <p className={styles.cardDescription}>{description}</p>

        <div className={styles.cardLinkWrapper}>
            <button className={styles.button}>
            <a href={`/projeto`}>{seeMore}</a></button>
        </div>

        </div>

    </div>
    );
}
